import { DialogActions,Stack } from '@mui/material';
import { createPage, PageContent } from "../../shared/components/PageBase";
import { useCRUDReducer } from "../../shared/components/crud/Reducer";
import { CRUDForm, CRUDService, CRUDType } from "../../shared/components/crud/index.d";
import { FormButtons } from "../../shared/components/FormButtons";
import { EPath } from "../../shared/util/EPath";
import { handleRequest } from "../../shared/util/ERequest";
import { useState } from "react";
import { Switchable } from '../../shared/components/Switchable';
import { FieldEmail } from '../../shared/Fields';
import EagletEmailIcon from '../../shared/images/Icon_Mail.png';


export interface UserInvite
{
    readonly email: string;
};

export const UserInvite_CT = new CRUDType<UserInvite>()
    .add("email", FieldEmail)
;
// TODO: CT type
// TODO: path constant
const User_CRUDService = new CRUDService(UserInvite_CT, new EPath("/api/user"));

export const RequestPasswordReset = createPage(() => {

    const reducer = useCRUDReducer(UserInvite_CT);
    const [showConfirmation, setShowConfirmation] = useState(false);
  
    const submit = () =>
    {
      let v = reducer.values;
      console.log("submit", v);

      handleRequest(User_CRUDService.postToFunction('password/request', v),
        (success) =>
        {
            console.log("password success", success);
            setShowConfirmation(true);
        },
        (err, json) =>
        {
            console.log("password error", err, json);
            reducer.onSubmitError(json);
        }
      );
    };

    return <PageContent>
        <Switchable value={showConfirmation} index={false}>
            <h1>Reset Password</h1>
            <p>To reset your password, please enter your email address below.</p>
            <Stack>
                <CRUDForm<UserInvite> 
                    type={UserInvite_CT}
                    values={reducer}
                    submit={submit}
                />

                <DialogActions>
                    <FormButtons
                        values={reducer}
                        submit={submit}
                        submitLabel="Reset password"
                    />
                </DialogActions>
            </Stack>
        </Switchable>
        <Switchable value={showConfirmation} index={true}>
            <h1>Reset Password</h1>
            <p>Please check your email for instructions to reset your password.</p>
            <img className='icon' src={EagletEmailIcon}/>
        </Switchable>
    </PageContent>
    ;
}, "Password reset")
